import React from "react";
import { Dialog, FormContainer } from "../index";
import styles from "./ConfirmationDialog.module.css";

const ConfirmationDialog = ({
  open,
  onClose,
  onConfirm,
  title,
  subtitle,
  text,
  translate,
  successTitle,
  successMessage,
  testid,
}) => {
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState(false);
  const [success, setSuccess] = React.useState(false);

  const onRightClick = async () => {
    if (error) {
      onClose();
      setError(false);
      return;
    }

    if (success) {
      onClose();
      return;
    }

    setLoading(true);

    try {
      await onConfirm();

      if (successMessage) {
        setSuccess(true);
      } else {
        onClose();
      }
    } catch (error) {
      setError(true);
    }

    setLoading(false);
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      className={styles.dialog}
      data-testid={testid || "confirmation-dialog"}
      data-error={error}
      data-success={success}
    >
      <FormContainer
        title={title}
        subtitle={subtitle}
        onClose={onClose}
        onClickLeft={onClose}
        hideLeftButton={error || success}
        onClickRight={onRightClick}
        rightButtonText={error || success ? translate("close") : translate("confirm")}
        loading={loading}
        error={error}
        translate={translate}
        message={{
          title: successTitle || "",
          subtitle: success ? successMessage : text,
        }}
      />
    </Dialog>
  );
};

export default ConfirmationDialog;
